"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Creative = _interopRequireDefault(require("../models/creative/Creative"));

var _RootRenderer = _interopRequireDefault(require("./render/RootRenderer"));

var _ContentStore = _interopRequireDefault(require("./store/ContentStore"));

var _CanvasFactory = _interopRequireDefault(require("./CanvasFactory"));

/*
 SnapPreview draws stuff in to a canvas context
 */
var SnapPreview = /*#__PURE__*/function () {
  /**
   * Canvas Factory
   * @type {CanvasFactory}
   */

  /**
   * Content Store
   * @type {ContentStore}
   */

  /**
   * Creative that Snap Preview will render
   * @type {Creative}
   */

  /**
   * Root BitMap Data
   * @type {RootRenderer}
   */

  /**
   *
   * @param {Creative} creative
   * @param {ContentStore} contentStore
   * @param {CanvasFactory} canvasFactory
   * @param {{
   *   canvasDimensions: Rectangle,
   *   canvasImageSmoothing: Boolean,
   *   filterProcessor:FilterProcessor,
   *   layerRendererCache:LayerRendererCache,
   *   rootCanvas:HTMLCanvasElement
   * }} options
   */
  function SnapPreview(creative, contentStore, canvasFactory) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    (0, _classCallCheck2["default"])(this, SnapPreview);
    (0, _defineProperty2["default"])(this, "_canvasFactory", null);
    (0, _defineProperty2["default"])(this, "_contentStore", null);
    (0, _defineProperty2["default"])(this, "_creative", null);
    (0, _defineProperty2["default"])(this, "_rootBitmap", null);

    if (!_Creative["default"].isCreative(creative)) {
      throw new Error('creative must be of type Creative');
    }

    if (!_ContentStore["default"].isContentStore(contentStore)) {
      throw new Error('contentStore must be of type ContentStore');
    }

    if (!_CanvasFactory["default"].isCanvasFactory(canvasFactory)) {
      throw new Error('canvasFactory must be of type CanvasFactory');
    }

    this._creative = creative;
    this._contentStore = contentStore;
    this._canvasFactory = canvasFactory; // Create the Root Bitmap Data object and then get the Root canvas layer

    this._rootBitmap = new _RootRenderer["default"](creative, contentStore, canvasFactory, options);
  }

  (0, _createClass2["default"])(SnapPreview, [{
    key: "cleanUp",
    value: function cleanUp() {
      // TODO cleanup in RootBitmap and so on (remove/get rid of old canvases)
      delete this._rootBitmap;
    }
    /**
     * Render the given creative at the current frame, using data from the provided ContentStore
     * @param {Number} currentFrame
     * @returns {HTMLCanvasElement}
     */

  }, {
    key: "renderFrame",
    value: function renderFrame(currentFrame) {
      if (!_Creative["default"].isCreative(this.creative)) return null; // Lets go to the mall everybody!

      return this._rootBitmap.getRootBitmap(currentFrame);
    }
  }, {
    key: "creative",
    get: function get() {
      return this._creative;
    }
    /**
     * Update creative when there are any changes. This requires a redraw.
     *
     * @param {Creative} creative
     */
    ,
    set: function set(creative) {
      var _this$_creative = this._creative,
          oldHeight = _this$_creative.height,
          oldWidth = _this$_creative.width;
      this._creative = creative;
      this._rootBitmap.creative = creative; // only update dimensions if necessary

      if (oldHeight !== creative.height || oldWidth !== creative.width) {
        this._rootBitmap.updateTransform();
      }
    }
  }]);
  return SnapPreview;
}();
/**
 * @param creative {Creative}
 * @param contentStore {ContentStore}
 * @param canvasFactory {CanvasFactory}
 * @param {{
 *   canvasDimensions: Rectangle,
 *   canvasImageSmoothing: Boolean,
 *   filterProcessor:FilterProcessor,
 *   layerRendererCache:LayerRendererCache,
 *   rootCanvas:HTMLCanvasElement
 * }} options
 * @returns {SnapPreview}
 */


var getSnapPreview = function getSnapPreview(creative, contentStore, canvasFactory, options) {
  return new SnapPreview(creative, contentStore, canvasFactory, options);
};

var _default = getSnapPreview;
exports["default"] = _default;